export let list = [
  {
    key: "p9",
    projectName: "Tic Tac Toe",
    langUsed: "React",
    projectDesc:
      "A classic Tic Tac Toe game built using React, where two players take turns marking spaces in a 3x3 grid to form a winning line.",
    gitRepoLink: "https://github.com/prakhargaba007/tic-tac-toe",
    gitPages: "https://prakhargaba007.github.io/tic-tac-toe/",
  },
  {
    key: "p1",
    projectName: "Expense Tracker",
    langUsed: "React",
    projectDesc:
      "A personal finance management tool that allows users to track their daily expenses and categorize them, built with React for an interactive UI.",
    gitRepoLink: "https://github.com/prakhargaba007/expense-trcker",
    gitPages: "https://prakhargaba007.github.io/expense-trcker/",
  },
  {
    key: "p2",
    projectName: "Final Countdown",
    langUsed: "React",
    projectDesc:
      "A countdown timer built with React, allowing users to set a target date and time while visually seeing the remaining time to the event.",
    gitRepoLink: "https://github.com/prakhargaba007/Final-Countdown",
    gitPages: "https://prakhargaba007.github.io/Final-Countdown/",
  },
  {
    key: "p5",
    projectName: "Place Picker",
    langUsed: "React",
    projectDesc:
      "A React-based app that allows users to search and select a location from a map. Integrated with the Google Maps API for real-time location picking.",
    gitRepoLink: "https://github.com/prakhargaba007/Place-Picker",
    gitPages: "https://prakhargaba007.github.io/Place-Picker/",
  },
  {
    key: "p3",
    projectName: "Investment Calculator",
    langUsed: "React",
    projectDesc:
      "A tool for calculating the returns on investments, taking into account the initial investment, interest rate, and duration, created using React.",
    gitRepoLink: "https://github.com/prakhargaba007/investment-calculator",
    gitPages: "https://prakhargaba007.github.io/investment-calculator/",
  },
  {
    key: "p4",
    projectName: "Login Page",
    langUsed: "React",
    projectDesc:
      "A simple yet stylish login page built with React, designed to provide a smooth and secure user authentication experience.",
    gitRepoLink: "https://github.com/prakhargaba007/Login-Page",
    gitPages: "https://prakhargaba007.github.io/Login-Page/",
  },
  {
    key: "p6",
    projectName: "Quiz App",
    langUsed: "React",
    projectDesc:
      "A React-based quiz application where users can answer multiple-choice questions. The app tracks the score and provides results at the end.",
    gitRepoLink: "https://github.com/prakhargaba007/Quiz-App",
    gitPages: "https://prakhargaba007.github.io/Quiz-App/",
  },
  {
    key: "p7",
    projectName: "React Counter",
    langUsed: "React",
    projectDesc:
      "A simple counter app created using React, allowing users to increment, decrement, and reset the count with an interactive UI.",
    gitRepoLink: "https://github.com/prakhargaba007/React-Counter",
    gitPages: "https://prakhargaba007.github.io/React-Counter/",
  },
  {
    key: "p8",
    projectName: "Shopping Website",
    langUsed: "React",
    projectDesc:
      "A mock e-commerce website created with React. It features product listings, a shopping cart, and a checkout page for a complete shopping experience.",
    gitRepoLink: "https://github.com/prakhargaba007/Shooping-Website",
    gitPages: "https://prakhargaba007.github.io/Shooping-Website/",
  },
  {
    key: "p10",
    projectName: "Task Tracker",
    langUsed: "React",
    projectDesc:
      "A task management application built with React that allows users to add, update, and delete tasks. It provides a streamlined way to manage daily to-dos.",
    gitRepoLink: "https://github.com/prakhargaba007/Task-Tracker",
    gitPages: "https://prakhargaba007.github.io/Task-Tracker/",
  },
  {
    key: "p11",
    projectName: "UsabilityHub Dummy Project",
    langUsed: "React",
    projectDesc:
      "A dummy project inspired by UsabilityHub, showcasing a simple React app structure and a basic design to demonstrate functionality and UI interaction.",
    gitRepoLink: "https://github.com/prakhargaba007/UsabilityHub-dummy-project",
    gitPages: "https://prakhargaba007.github.io/UsabilityHub-dummy-project/",
  },
  {
    key: "p12",
    projectName: "E-Commerce with Payment",
    langUsed: "React",
    projectDesc:
      "A full-fledged e-commerce application built with React, featuring payment integration. Users can browse products, add items to the cart, and make purchases through a secure payment gateway.",
    gitRepoLink: "https://github.com/prakhargaba007/e-commerce",
    gitPages: "https://e-commercee-anhs.onrender.com/",
  },
];
